import { useEffect } from 'react';
import { useZettle } from '~Hooks';
import { RefundProps } from '../types';

export const RefundIzettle = (props: RefundProps) => {
  const zettle = useZettle();

  useEffect(() => {
    zettle.refund({
      orderId: props.orderId,
      transactionId: props.transactionId,
      amount: props.amount,
      onCompleted: props.onCompleted,
      onFail: props.onFail,
    });
  }, []);

  return null;
};
